import { merge } from 'lodash-es';

import { DeepPartial } from '../types';

export const mergeDeep = <T>(...sources: (T | DeepPartial<T>)[]): T =>
  // lodash merge mutates its first argument; provide an empty object to keep it immutable
  merge({}, ...sources) as T;

export const deepFreeze = (object: any) => {
  // Retrieve the property names defined on object
  const propNames = Object.getOwnPropertyNames(object);

  // Freeze properties before freezing self
  propNames.forEach((name) => {
    const value = object[name];

    if (value && typeof value === 'object') {
      deepFreeze(value);
    }
  });

  return Object.freeze(object);
};
